import { Builder } from './components/Builder'
import { InputColor } from './components/CustomInputs/InputColor'
import { InputUpload } from './components/CustomInputs/InputUpload'
import { RadioCard } from './components/CustomInputs/RadioCard'
import { RRulePicker } from './components/CustomInputs/RRulePicker'
import { TagWall } from './components/CustomInputs/TagWall'
import { FormBase } from './components/FormBase'
import { FormConfigurationList } from './components/List/List'
import { FormConfigurationModal } from './components/Modal'
import { Step } from './components/Step'
import { Viewer } from './components/Viewer'

export const FeatureFormConfigurationClient = {
  Builder,
  Viewer,
  Step,
  Modal: FormConfigurationModal,
  List: FormConfigurationList,
  FormBase,
  InputColor,
  InputUpload: InputUpload,
  RadioCard: RadioCard,
  TagWall: TagWall,
  RRulePicker: RRulePicker,
}
